import { EPaymentInvoiceType } from '../enums/payment.enum';

export const MEMO_PAYABLE_TYPE = {
  [EPaymentInvoiceType.CN]: {
    id: EPaymentInvoiceType.CN,
    value: 'CustomerCreditNote'
  },
  [EPaymentInvoiceType.IV]: {
    id: EPaymentInvoiceType.IV,
    value: 'SupplierInvoice'
  },
  [EPaymentInvoiceType.SCN]: {
    id: EPaymentInvoiceType.SCN,
    value: 'SupplierCreditNote'
  },
};

